import React, { Component } from 'react';
import axios from "axios";
import { Link } from 'react-router-dom';

import {NotificationContainer, NotificationManager} from 'react-notifications';

import AccountMenu from './AccountMenu';

class OrdersTrack extends Component {

    constructor(props) {
        super(props);
        this.state = {
            wishlist:[],
            serviceCheck:false,
        }   
    }

    // async componentDidMount() {
    //     const params = new URLSearchParams();
    //     params.append('token', localStorage.getItem('byos_token'));
    //     try {
    //       const response = await axios.post('https://shop.mybadge.co.in/api/apiv1/wishlistList', params);
    //        let resVal=response.data;
    //         if(resVal.status==='success'){
    //             this.setState({wishlist:resVal.data});
    //             this.setState({serviceCheck:true});
    //         }
    //     } catch (error) {
    //         this.setState({serviceCheck:true});
    //       console.error(error);
    //     }

    // }


    render() {
        const { mobile_number, password }  = this.state ;

        //  if(this.state.serviceCheck===false)
        // return (<Loader/>);

        return (
            <div >

        <div class="ps-categogy ps-categogy--separate">
            <div class="container whiteContainer">

                <div class="row">
                    <div class="col-12 col-md-3">
                        <AccountMenu/>
                    </div>
                    <div class="col-12 col-md-9">
                
                <h4 class="ps-form__title customeTitleName">
                    My Orders
                    &nbsp; <i class="fa fa-angle-double-right" aria-hidden="true"></i> &nbsp;
                    Track Order
                </h4>


                            <br/>
                            <br/>
                            <h4 class="text-center">No orders found</h4>


                            </div>
                        </div>
                    </div>                    
                </div>

                <NotificationContainer/>
            </div>
        );
    }
}

export default OrdersTrack;